<template>
  <div class="main" ref="indoorSetting">

    <div class="device-container">
      <!--      漏水线-->
      <canvas :height="initHeight" :width="initWidth" id="slackLineContainer"
              ref="slackLineContainer" style="position: absolute;"></canvas>
      <!--      背景图-->
      <img
        :src="spaceInfo===undefined || spaceInfo===null || spaceInfo.bgImage===null ||spaceInfo.bgImage==='' ? require('@/assets/images/no-bg.png') : $ftpUrl + spaceInfo.bgImage"
        @load="resizeDrawSlackLineContainer"
        alt=""
        class="bg-img"
        ref="spaceBackgroundImage">
      <!--      设备logo-->
      <div class="device-icon-container">

        <div
          :key="index"
          v-for="(item,index) in spaceMap.filter(item => item.xoffset && item.yoffset && deviceListWidthId[item.deviceId] && deviceListWidthId[item.deviceId].typeEngName !== 'PM_WLD')">
          <div
            :style="{'left':item.xoffset*imgWidth/100-17+'px','top':item.yoffset*imgHeight/100-46 +'px'}"
            @touchstart="showDeviceDetails(item.deviceId)"
            @click="showDeviceDetails(item.deviceId)"
            class="pointer device"
            style="position:absolute;">
            <!--图标-->
            <!-- <div style="display: block;width: 34px;height: 46px">
              <div class="device-icon"
                   style="display: block;width: 34px;height: 46px">
                <div :class="deviceListWidthId[item.deviceId].status === 0 ? '' :'blinks'"
                     :style="{backgroundImage:  deviceListWidthId[item.deviceId].status === 0 ?
                   'url(' + deviceListWidthId[item.deviceId].icon + ')' : 'url(' + deviceListWidthId[item.deviceId].iconAlarm + ')',
                   display: displaySetting.type !== '1' && displaySetting.type !== '4' ? 'block' : 'none'}"
                     style="width: 34px;height: 46px;-moz-background-size:100% 100%; background-size:100% 100%;"></div>
              </div>
            </div> -->

            <!--测点面板-->
            <el-popover
              :value="pointListWidthId[item.deviceId] !== undefined && pointListWidthId[item.deviceId].pointList !== undefined && pointListWidthId[item.deviceId].pointList.length > 0"
              placement="bottom"
              trigger="manual"
              style="font-size: 12px"
              v-if="(displaySetting.type === '3' || displaySetting.type === '4') && displaySetting.display !== '0' && pointListWidthId[item.deviceId] !== undefined"
              :width="deviceListWidthId[item.deviceId].typeEngName === 'PM_THC' ? 75 : 200">
              <span class="bot"></span>
              <span class="cover"></span>
              <!--温湿度-->
              <span :key="point.code" v-for="point in pointListWidthId[item.deviceId].pointList">
                <div v-if="pointCode.indexOf(point.code) > -1">
                  {{
                    pointListWidthId[item.deviceId].historyData && pointListWidthId[item.deviceId].historyData[point.id] ?
                      pointListWidthId[item.deviceId].historyData[point.id].pointValueName : '--'
                  }}
                </div>
              </span>
              <!--其他测点值-->
              <div :key="point.id" v-for="point in pointListWidthId[item.deviceId].pointList">
                <div class="text-left" style="margin-left: 20px;line-height: 22px;"
                     v-if="pointCode.indexOf(point.code) < 0">
                  <span>{{ point.name }}：</span>
                  <span>{{
                      pointListWidthId[item.deviceId].historyData && pointListWidthId[item.deviceId].historyData[point.id] ?
                        pointListWidthId[item.deviceId].historyData[point.id].pointValueName : '--'
                    }}
                    </span>
                </div>
              </div>
            </el-popover>

            <!--设备名字-->
            <div
              :style="{backgroundColor:  deviceListWidthId[item.deviceId].status === 0 ? 'rgba(0,111,255,0.5)' : 'rgba(249, 88, 87, 0.5)',
              display: displaySetting.type === '1' || displaySetting.type === '2' ? 'block' : 'none'}"
              class="rounded-sm"
              style="color: #fff;font-size: 1rem;padding-left:20px;padding-right:20px;margin-left: 15px;line-height: 28px;margin-top: -30px;">
              {{ item.deviceName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getSpaceInfoById} from "@/network/space-info";
import {
  getByTypeIdsAndSpaceId,
  getDeviceListBySpaceIdAndCategoryTagId,
  getDeviceListBySpaceIdAndDeviceIds
} from "@/network/device-info";
import {getSpaceMap} from "@/network/space-map";
import elementResizeDetectorMarker from 'element-resize-detector';
import {listByDeviceId} from "@/network/device-measuring-point";
import {getHistoryByDevicePoint} from "@/network/measuring-point-history";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "IndoorSetting",
  mixins: [platenLayoutEdit],
  props: {
    spaceId: {
      type: String,
      default: () => '0'
    },
    displaySetting: {
      type: Object,
      default: () => {
      }
    },
  },
  data() {
    return {
      spaceInfo: {},
      spaceMap: [],
      deviceListWidthId: {},
      pointListWidthId: {},
      deviceList: [],
      deviceListId: [],
      imgWidth: 0,
      imgHeight: 0,
      initWidth: 0,
      initHeight: 0,
      pointCode: ['tm', 'hu']//'tcv', 'hv',
    }
  },
  mounted() {
    this.watchSize(); //监听元素大小变化
    this.getSpaceInfo(this.spaceId)
    window.onresize = () => {
      return (() => {
        this.resizeDrawSlackLineContainer()
      })();
    };
  },
  created() {
    window.onresize = () => {
      this.resizeDrawSlackLineContainer()
    }
    this.$store.dispatch('addIntervalObj', {
      'updateIndoorSetting:5000': () => {
        this.getDeviceList()
      }
    })
  },
  destroyed() {
    window.onresize=null
    this.$store.dispatch('removeIntervalObj', 'updateIndoorSetting')
    this.$store.dispatch('removeIntervalObj', 'IndoorSettingTimerSelectDevice')
  },
  watch: {
    spaceId(newVal) {
      this.spaceMap = []
      this.deviceList = []
      this.getSpaceInfo(newVal)
    },
  },
  methods: {
    getDisplayPoint() {
      //常显设置
      if (this.displaySetting.display === '1') {
        //按设备类型
        getByTypeIdsAndSpaceId(this.spaceInfo.id, null, this.displaySetting.checkboxList).then(res => {
          if (res.code === 0) {
            this.setPointList(res.data)
          }
        })
      } else if (this.displaySetting.display === '2') {
        //按类型标签
        getDeviceListBySpaceIdAndCategoryTagId(this.spaceInfo.id, null, this.displaySetting.checkboxList).then(res => {
          if (res.code === 0) {
            this.setPointList(res.data)
          }
        })
      } else if (this.displaySetting.display === '3') {
        //按设备
        getDeviceListBySpaceIdAndDeviceIds(this.spaceInfo.id, this.displaySetting.checkboxList).then(res => {
          if (res.code === 0) {
            this.setPointList(res.data)
          }
        })
      }
    },
    setPointList(deviceList) {
      if (deviceList.length > 0) {
        deviceList.forEach(item => {
          //获取测点
          listByDeviceId(item.id).then(res => {
            if (res.code === 0) {
              item.pointList = res.data.filter(point => point.spaceShow)
              const pointCode = res.data.filter(point => point.spaceShow).map(item => item.code)
              //获取测点值
              if (pointCode.length > 0) {
                getHistoryByDevicePoint({
                  deviceId: item.id,
                  pointCodes: pointCode
                }).then(res => {
                  if (res.code === 0) {
                    item.historyData = {}
                    res.data.forEach(value => {
                      item.historyData[value.pointId] = value
                    })
                  }
                })
              }
            }
          })
          this.pointListWidthId[item.id] = item
        })
      }
    },
    //监听元素大小变化
    watchSize() {
      const that = this;
      let marker = elementResizeDetectorMarker();
      marker.listenTo(that.$refs.indoorSetting, () => {
        that.$nextTick(() => {
          that.resizeDrawSlackLineContainer()
        })
      })
    },
    getDeviceList() {
      getDeviceListBySpaceIdAndCategoryTagId(this.spaceInfo.id, null).then(res => {
        this.deviceList = []
        if (res.data) {
          this.deviceList = res.data
          this.deviceListWidthId = {}
          this.deviceListId = []
          this.deviceList.forEach(device => {
            this.deviceListId.push(device.id)
            this.deviceListWidthId[device.id] = device
          })
          this.getSpaceMap(this.spaceInfo.id)
        }
      })
    },
    getSpaceMap(spaceId) {
      if (spaceId === '' || spaceId === null || spaceId === undefined) {
        return
      }
      getSpaceMap(spaceId).then(res => {
        if (res.data) {
          this.spaceMap = res.data
          this.getDisplayPoint();
          this.drawSlackLine()
        }
      })
    },
    getSpaceInfo(id) {
      if (id === '') {
        return
      }
      getSpaceInfoById(id).then(res => {
        if (res.data) {
          this.spaceInfo = res.data
          this.getDeviceList()
        }
      })
    },
    // 重置漏水线大小
    resizeDrawSlackLineContainer() {
      this.imgHeight = this.$refs.spaceBackgroundImage.height
      this.imgWidth = this.$refs.spaceBackgroundImage.width
      if (!this.$refs.slackLineContainer || !this.$refs.spaceBackgroundImage) {
        return
      }
      setTimeout(() => {
        if (this.$refs.slackLineContainer && this.$refs.spaceBackgroundImage) {
          this.$refs.slackLineContainer.style.height = this.$refs.spaceBackgroundImage.height + 'px'
          this.$refs.slackLineContainer.style.width = this.$refs.spaceBackgroundImage.width + 'px'
        }
      }, 100)
    },
    // 画漏水线
    drawSlackLine() {
      if (!this.$refs.slackLineContainer) {
        return
      }
      let canvasObj = this.$refs.slackLineContainer.getContext('2d')
      canvasObj.lineWidth = 5
      let slackLineDevice = this.spaceMap.filter(item => item.xoffset && item.yoffset && this.deviceListWidthId[item.deviceId] && this.deviceListWidthId[item.deviceId].typeEngName === 'PM_WLD')
      // 清空画布
      canvasObj.clearRect(0, 0, this.$refs.slackLineContainer.width, this.$refs.slackLineContainer.height);
      // 开始画线
      slackLineDevice.forEach(map => {
        let deviceInfo = this.deviceListWidthId[map.deviceId];
        canvasObj.beginPath()
        canvasObj.strokeStyle = deviceInfo.status === 0 ? 'green' : 'rgba(191, 40, 49, 0.85)'
        let yArray = map.yoffset.split(',');
        map.xoffset.split(',').forEach((item, index) => {
          if (index === 1) {
            canvasObj.moveTo(parseFloat(item), parseFloat(yArray[index]))
          } else if (index !== 1 && index !== 0) {
            canvasObj.lineTo(parseFloat(item), parseFloat(yArray[index]))
          } else {
            this.initWidth = parseFloat(item)
            this.initHeight = parseFloat(yArray[index])
          }
        })
        canvasObj.stroke();
      })
    },
    showDeviceDetails(deviceId) {
      if (this.isPlatenLayoutEditing) return
      this.$emit("showDeviceDetail", deviceId)
    }
  }
}
</script>

<style>
.main {
  width: 100%;
  height: 100%;
}

.bg-img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
}

.device-container {
  width: 100%;
  height: 100%;
  margin: auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.device-icon-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border: none;
}

/*设备图标*/
.device-icon {
  width: 34px;
  height: 46px;
  position: absolute;
}

.image-marker__dot {
  width: 35px;
  height: 35px;
  cursor: pointer;
  border-radius: 50%;
  position: absolute;
  opacity: 0.8;
  line-height: 20px;
  background-repeat: no-repeat;
  background-size: 65%;
  background-position: center;
}

.device .el-popover {
  background: rgba(37, 53, 75, 0.95);
  color: #fff;
  border: 1px solid rgba(34, 122, 197, 1);
  text-align: center;
  margin: 9px -12px;
  min-width: 75px !important;
}

/*边框线*/
.bot {
  border-width: 10px;
  border-style: solid dashed dashed;
  border-color: transparent transparent rgba(34, 122, 197, 1);
  position: absolute;
  left: 18px;
  top: -21px;
}
/*底色*/
.cover {
  border-width: 9px;
  border-style: solid dashed dashed;
  border-color: transparent transparent rgba(37, 53, 75, 0.95);
  position: absolute;
  left: 19px;
  top: -18px;
}
</style>
